import fetch from 'auth/FetchInterceptor'

const UserService = {}

UserService.getDataForCurrentUser = function () {
	return fetch({
		url: 'users/me',
		method: 'get'
	});
}

UserService.changeTabletCardMode = function (id) {
	return fetch({
		url: 'enter/table-mode-toggle/' + id,
		method: 'put',
		data: {
			'tableMode': true
		}
	});
}

UserService.rolesByUser = function (key) {
	return fetch({
		url: 'roles/' + key,
		method: 'get'
	});
}

UserService.userPrograms = function (currentUrl) {
	return fetch({
		url: 'menu-items?currentUrl=' + currentUrl,
		method: 'get'
	});
}

UserService.checkRegistraionToken = function (token) {
	return fetch({
		url: 'registration-token/' + token,
		method: 'put'
	});
}

UserService.userSearchAdmin = function (country, firstName, lastName, place, username, userRole, address, page) {
	return fetch({
		url: 'search/users?page=' + page + '&address='+ address + '&country=' + country + '&firstName=' + firstName + '&userRole=' + userRole + '&username=' + username + '&lastName=' + lastName  + '&place=' + place,
		method: 'get'
	});
}

UserService.getUserById = function (id) {
	return fetch({
		url: 'users/' + id,
		method: 'get'
	});
}


UserService.createNewAdmin = function (data) {
	return fetch({
		url: 'new-user-account',
		method: 'post',
		data: data
	});
}

UserService.update = function (data, id) {
	return fetch({
		url: 'user-update/' + id,
		method: 'put',
		data: data
	});
}

UserService.getAll = function (page) {
	return fetch({
		url: 'users?page=' + page,
		method: 'get'
	});
}

UserService.delete = function (key) {
	return fetch({
		url: 'users/' + key,
		method: 'delete'
	});
}

export default UserService;